"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STATUS = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var STATUS = {
  success: 'success',
  error: 'error',
  neutral: ''
};
exports.STATUS = STATUS;

var Validation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Validation, _React$Component);

  var _super = _createSuper(Validation);

  function Validation(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Validation);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function (e) {
      var v = _this.validate(e.target.value);

      if (v) {
        _this.handleValidate(_objectSpread(_objectSpread({}, v), {}, {
          state: v.valid ? STATUS.success : STATUS.error,
          event: e
        }));
      } else {
        _this.handleValidate({
          message: null,
          state: STATUS.neutral,
          event: e
        });
      }

      _this.props.children.props.onBlur && _this.props.children.props.onBlur(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (e) {
      var v = _this.validate(e.target.value);

      if (v) {
        _this.handleValidate(_objectSpread(_objectSpread({}, v), {}, {
          state: v.valid ? STATUS.success : STATUS.neutral,
          message: v.message,
          event: e
        }));
      } else {
        _this.handleValidate({
          message: null,
          state: STATUS.neutral,
          event: e
        });
      }

      _this.props.children.props.onChange && _this.props.children.props.onChange(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFocus", function (e) {
      var v = _this.validate(e.target.value);

      if (v) {
        _this.handleValidate(_objectSpread(_objectSpread({}, v), {}, {
          message: v.message,
          state: v.valid ? STATUS.success : STATUS.neutral,
          event: e
        }));
      } else {
        _this.handleValidate({
          message: null,
          state: STATUS.neutral,
          event: e
        });
      }

      _this.props.children.props.onFocus && _this.props.children.props.onFocus(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleValidate", function (_ref) {
      var state = _ref.state,
          _ref$message = _ref.message,
          message = _ref$message === void 0 ? null : _ref$message,
          event = _ref.event;

      if (state !== _this.state.validationState || message !== _this.state.validationMessage) {
        _this.setState({
          validationState: state,
          validationMessage: message
        });

        _this.props.onValidate({
          state: state,
          message: message,
          event: event
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validate", function (value) {
      if ((0, _utils.isBlank)(value)) {
        var required = _this.props.required;
        return {
          valid: !required,
          message: required ? 'This field is required' : null
        };
      }

      return _this.props.validate(value);
    });
    _this.state = {
      validationState: _this.props.validationState,
      validationMessage: _this.props.validationMessage
    };
    return _this;
  }

  (0, _createClass2.default)(Validation, [{
    key: "render",
    value: function render() {
      var Child = this.props.children.type;
      return /*#__PURE__*/_react.default.createElement(Child, (0, _extends2.default)({}, this.props.children.props, {
        validationState: this.props.validationState ? this.props.validationState : this.state.validationState,
        validationMessage: this.props.validationMessage ? this.props.validationMessage : this.state.validationMessage,
        onBlur: this.handleBlur,
        onChange: this.props.onChange ? this.props.onChange : this.handleChange,
        onFocus: this.handleFocus
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        validate: _propTypes.default.func,
        required: _propTypes.default.bool,
        validationState: _propTypes.default.oneOf([STATUS.success, STATUS.error, STATUS.neutral]),
        validationMessage: _propTypes.default.string,
        onValidate: _propTypes.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        required: false,
        onValidate: function onValidate() {},
        validate: function validate() {
          return {
            valid: true,
            message: null
          };
        }
      };
    }
  }]);
  return Validation;
}(_react.default.Component);

exports.default = Validation;